import { Alert, Button, FormGroup, Link, Loader} from 'arag-ui-lib';
import React from 'react';

const InternalAlertForm = (props) => {
    const {
        isEdit,
        solicitorGroup,
        lawsysFirms,
        changeFormData,
        formData,
        handleSubmit,
        user,
        internalAlertForm,
        groups,
        handleDelete,
        goBack
    } = props;
    const isUserAllowed = user.loggedInUser.allowedToCreateInternalAlerts
    const loading = internalAlertForm.posting || internalAlertForm.patching || internalAlertForm.deleting;
    return (
        <div className="col-sm-12 applicationsAndPolicies-wrapper">
            {isEdit && (
                internalAlertForm.fetching ||
                groups.fetchingSolicitorGroupCaseTypes ||
                lawsysFirms.fetchingLawsysFirmGroup ||
                internalAlertForm.solicitorCaseTypes.length == 0
            )
                ? <Loader variant='list' /> :

                <form
                    onSubmit={(e) => {
                        e.preventDefault()
                        handleSubmit()
                    }}
                >
                    <div className="row">
                        <h2 className="col-sm-12 applicationsAndPolicies-h2">{isEdit ? 'Update Internal Alert' : 'Create new Internal Alert'}</h2>
                    </div>
                    <FormGroup
                        labelSize="col-sm-3"
                        inputSize="col-sm-6"
                        label="Solicitor Firm"
                        variant="select"
                        inputProps={{
                            required: true,
                            disabled: !isUserAllowed,
                            onChange: ((evt) => { changeFormData(evt.target.name, parseInt(evt.target.value)) }),
                            options: [{ key: '', label: '' }, ...lawsysFirms.lawsysFirms.map(c => { return { key: c.id, label: c.name } })],
                            value: formData.solicitorFirmId,
                            name: "solicitorFirmId",
                        }}
                    />
                    {lawsysFirms.fetchingLawsysFirmGroup && <div className="text-center" >
                        <Loader variant='inline' />
                    </div>
                    }
                    {internalAlertForm.solicitorCaseTypes.length > 0 &&
                        !lawsysFirms.fetchingLawsysFirmGroup &&
                        solicitorGroup != '' &&
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Case Type"
                            variant="select"
                            inputProps={{
                                required: true,
                                disabled: !isUserAllowed,
                                onChange: ((evt) => { changeFormData(evt.target.name, parseInt(evt.target.value)) }),
                                options: [{ key: '', label: '' }, ...internalAlertForm.solicitorCaseTypes.map(c => { return { key: c.id, label: c.name } })],
                                value: formData.selectedCaseType,
                                name: "selectedCaseType",
                            }}
                        />
                    }

                    {internalAlertForm.solicitorSubCaseTypes.length > 0 &&
                        formData.selectedCaseType != '' &&
                        internalAlertForm.solicitorSubCaseTypes.some(c => c.caseTypeId == formData.selectedCaseType) &&
                        <FormGroup
                            labelSize="col-sm-3"
                            inputSize="col-sm-6"
                            label="Sub Case Type"
                            variant="select"
                            inputProps={{
                                disabled: !isUserAllowed,
                                onChange: ((evt) => { changeFormData(evt.target.name, parseInt(evt.target.value)) }),
                                options: [{ key: '0', label: 'None' }, ...internalAlertForm?.solicitorSubCaseTypes
                                    .filter(sc => sc?.caseTypeId == formData?.selectedCaseType)
                                    .map(c => { return { key: c?.id, label: c?.name } })],
                                value: formData?.selectedSubCaseType,
                                name: "selectedSubCaseType",
                            }}
                        />
                    }
                    {formData.selectedCaseType != '' &&
                        <div>
                            <FormGroup
                                labelSize='col-sm-3'
                                inputSize="col-sm-6"
                                label="Internal Alert"
                                variant="textarea"
                                inputProps={{
                                    required: true,
                                    disabled: !isUserAllowed,
                                    required: true,
                                    onChange: ((evt) => { changeFormData(evt.target.name, evt.target.value) }),
                                    name: 'internalAlertText',
                                    value: formData?.internalAlertText,
                                }}
                            />
                            <FormGroup
                                labelSize={'col-sm-3'}
                                inputSize={'col-sm-6'}
                                label={'Policy Live Date From'}
                                variant={'date'}
                                inputProps={{
                                    required: true,
                                    name: 'validFrom',
                                    dateInputProps: {
                                        required: true,
                                        disabled: !isUserAllowed,
                                        onChange: ((evt) => { changeFormData('validFrom', evt) }),
                                        autoComplete: 'off',
                                        dateFormat: 'dd/MM/yyyy',
                                        selected: formData?.validFrom,
                                        placeholderText: 'DD/MM/YYYY'
                                    },
                                }}
                            />
                            <FormGroup
                                labelSize={'col-sm-3'}
                                inputSize={'col-sm-6'}
                                label={'Policy Live Date To'}
                                variant={'date'}
                                inputProps={{
                                    name: 'validTo',
                                    value: formData.validTo,
                                    required: false,
                                    dateInputProps: {
                                        required: false,
                                        disabled: !isUserAllowed,
                                        minDate: formData.validFrom,
                                        dateFormat: 'dd/MM/yyyy',
                                        onChange: ((evt) => { changeFormData('validTo', evt) }),
                                        autoComplete: 'off',
                                        selected: formData.validTo,
                                        placeholderText : 'DD/MM/YYYY'
                                    },
                                }}
                            />
                            <div className='row' style={{ display: 'flex', alignContent: 'center' }} >
                                <div className='col-xs-offset-3  col-sm-8' style={{ display: 'flex', gap: 10, alignContent: 'center' }}>

                                    {isUserAllowed &&
                                        <Button variant="primary"
                                         disabled={loading}
                                         label="Save"
                                         type={'submit'}
                                         btnType="submit"
                                         arrowDirection="right"
                                        />}
                                    <Button
                                        variant="quaternary"
                                        label="Cancel"
                                        arrowDirection="right"
                                        disabled={loading}
                                        onClick={goBack}
                                    />
                                    {formData?.id && isUserAllowed && <div style={{ alignSelf: 'center' }}>
                                        <Link
                                            variant="tertiary"
                                            arrowDirection="left"
                                            disabled={loading}
                                            label="Delete"
                                            onClick={handleDelete}
                                        />
                                    </div>}
                                    {loading && <Loader variant="inline" />}
                                </div>
                            </div>

                            {internalAlertForm.response !== '' && <Alert variant="success" label={internalAlertForm.response} />}
                            {internalAlertForm.badResponse !== '' && <Alert variant="error" label={internalAlertForm.badResponse} />}
                        </div>}
                </form>}
        </div>
    )
}
export default InternalAlertForm
